import { useState } from "react";
import cuisinier from "../../assets/cuisinier.png";
import "../styles/testimonial.css";

import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { useSelector } from "react-redux";
import { t } from "../../translations";

const elements = [
  {
    desc: "Lorem ipsum dolor sit amet consectetur. Aliquet augue lorem ac fermentum elementum in amet faucibus enim.",
    person: "Henriette Kouamé",
    sub_person: "Chef originaire de Côte d'Ivoire",
    img: cuisinier
  },
  {
    desc: "Lorem ipsum dolor sit amet consectetur. Aliquet augue lorem ac fermentum elementum in amet faucibus enim.",
    person: "Henriette Kouamé 2",
    sub_person: "Chef originaire de Côte d'Ivoire 2",
    img: cuisinier
  }
];

const TestitmonialChef = () => {
  const [selected, setSelected] = useState(0);
  const lang = useSelector((state) => state.lang);

  return (
    <div className="testimonial-description-pani">
      <div className="testimonial-description">
        <hr />
        <h2>{t("opportunity_pani.chef_testimonials", lang, false)}</h2>
        <hr />
        <p dangerouslySetInnerHTML={{ __html: elements[selected]?.desc }} />
        <div className="testimonial-more-info">
          <span>
            <b>{elements[selected]?.person}</b>
            <br />
            {elements[selected]?.sub_person}
          </span>
          <div className="testimonial-btn">
            <span
              className="btn-left"
              onClick={() => {
                if (selected === 0) {
                  return;
                }
                setSelected(selected - 1);
              }}
            >
              <AiOutlineArrowLeft size={18} color={"#000"} />
            </span>
            <span
              className="btn-right"
              onClick={() => {
                if (selected === elements.length - 1) {
                  return;
                }
                setSelected(selected + 1);
              }}
            >
              <AiOutlineArrowRight size={18} color={"#fff"} />
            </span>
          </div>
        </div>
      </div>
      <img src={elements[selected]?.img} alt="" />
    </div>
  );
};

export default TestitmonialChef;
